// import utils from "@/utils";
// import insider from "./insider";
import Qs from "qs"
import { Ajax } from "../utils/base.js";
import IP from "../config/config"
// const IP = process.env.VUE_APP_BASEURL;
export function getInfoNews (param) {
    const url = IP.apis() + '/v1/news/info';
    return Ajax(url, param, "GET");
}
export function getRecommendThird (param) {
    const url = IP.apis() + '/v1/news/recommend-new';
    return Ajax(url, param, "GET");
}
// 获取用户信息
export function checkInfotime (param) {
    const url = IP.apis() + '/v1/news/first-time';
    return Ajax(url, param, "GET");
}
// 获取用户信息第三方????
export function checkThirdInfotime (param) {
    const url = IP.apis() + '/v1/news/third-first-time';
    return Ajax(url, param, "GET");
}
// 获取评论
export function getComment (param) {
    const url = IP.commentApis() + '/comments/getlist';
    return Ajax(url, param, "GET");
}
// 获取情报列表
export function getIntelligenceListApi (param) {
    const url = IP.dcApis() + '/data/getDataInformationList';
    return Ajax(url, param, "GET");
}
// 获取列表
export function getDataTypeListApi (param) {
    const url = IP.dcApis() + '/data/getDataTypeList';
    return Ajax(url, Qs.stringify(param), "POST");
}
// 获取雷达类型列表
export function getInformLevelApi (param) {
    const url = IP.dcApis() + '/data/getInformLevel';
    return Ajax(url, param, "GET");
}
// 获取雷达列表
export function getRaderListApi (param) {
    const url = IP.dcApis() + '/data/getRadarInformationList';
    return Ajax(url, param, "GET");
}
// 获取one
export function getColdHisApi (param, urlApi) {
    const url = IP.djApis() + urlApi;
    return Ajax(url, param, "GET");
}
// 获取two
export function getForwardApi (param) {
    const url = IP.dcApis() + '/data/forward';
    return Ajax(url, param, "GET");
}
// 检测是否自动续费
export function iosIsAutoPay (param) {
    const url = IP.passportApis() + '/data/getAutoPaySetMeal';
    return Ajax(url, param, "GET");
}
